import { Base } from './base.model';

export class StripeAccount extends Base {
  public stripeUserIdentifier: string;
  public stripeAccountCreationDate: Date;
  public isStripeAccountIssue: boolean;
  public userId: number;
}
